import PropTypes from 'prop-types';

export default function OutlineRecurrences(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M10 2v4M10 14v4M4.344 4.344l2.828 2.828M12.83 12.83l2.829 2.828M2 10h4M14 10h4M4.344 15.656l2.828-2.828M12.83 7.17l2.828-2.829"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineRecurrences.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
